<form [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate()" RestrictFocus>
    <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4"><label>{{ 'common.certification_name' | translate}}</label></div>
            <div class="ui-grid-col-8"><input formControlName="name" pInputText/></div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4"><label>{{ 'common.classification_parent' | translate}}</label></div>
            <div class="ui-grid-col-8">
                <p-dropdown [style]="{'width':'100%'}" formControlName="parent_id" [options]="classifications_items"
                            [(ngModel)]="selected_classification"></p-dropdown>
            </div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4"><label>{{ 'common.classification_type' | translate}}</label></div>
            <div class="ui-grid-col-8">
                <p-dropdown [style]="{'width':'100%'}" formControlName="classification_type_id"
                            [options]="classification_types"
                            [(ngModel)]="selected_classification_type"></p-dropdown>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
            <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                    [disabled]="!addEditForm.valid || !addEditForm.dirty"
                    [label]="editingElement.id ? ('common.edit_classification' | translate) : ('common.add_classification' | translate)"></button>
        </div>
    </p-footer>
</form>


// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-form.component.html